import { Country } from 'src/api/zrm';

import { getLocale } from './getLocale';

export const compareStrings = (a: string, b: string, country: Country = Country.SE): number => (a ?? '')
  .localeCompare(b ?? '', getLocale(country), { ignorePunctuation: true }); // ignores case
